import { collection, doc, getDoc, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase';

// Hall of Fame: Ranking einer Saison laden und den Eintrag bauen.
// Genutzt von der Hall-of-Fame-Verwaltung und vom Saisonabschluss im Dashboard.
// Format von hallOfFame/{saison-id} unverändert (docs/DATENMODELL.md).

export function sortiereRanking(liste) {
  const s = [...liste].sort((a, b) => b.punkte - a.punkte);
  s.forEach((u, i) => { u.platz = i + 1; });
  return s;
}

// Endstand aus den punkte-Docs der Saison (ein Doc je Spieler) plus Namen
export async function ladeSaisonRanking(saisonId) {
  const punkteSnap = await getDocs(query(collection(db, 'punkte'), where('saison', '==', saisonId)));
  const userDocs = await Promise.all(punkteSnap.docs.map(p => getDoc(doc(db, 'users', p.data().userId))));
  const daten = punkteSnap.docs.map((p, i) => {
    const d = p.data();
    return {
      userId: d.userId,
      username: userDocs[i].exists() ? (userDocs[i].data()?.displayName || 'Unbekannt') : 'Unbekannt',
      punkte: d.gesamt || 0,
      gesamtSpiele: d.gesamtSpiele || 0,
      gesamtBonus: d.gesamtBonus || 0
    };
  });
  return sortiereRanking(daten);
}

// Top 3 mit Punktgleichstand (Logik unverändert aus der Verwaltung)
export function top3Plaetze(ranking) {
  const top3 = [];
  let platz = 1;
  let vergeben = 0;
  for (let i = 0; i < ranking.length && vergeben < 3; i++) {
    const sp = ranking[i];
    const eintrag = top3.find(p => p.platz === platz);
    if (!eintrag) {
      top3.push({ platz, spieler: [sp] });
      vergeben++;
    } else if (Math.abs(sp.punkte - eintrag.spieler[0].punkte) < 0.01) {
      eintrag.spieler.push(sp);
    } else {
      platz = i + 1;
      top3.push({ platz, spieler: [sp] });
      vergeben++;
    }
  }
  return top3;
}

export function baueHallOfFameEintrag(ranking, saisonName, erstelltVon) {
  return {
    saison: saisonName,
    top3Plaetze: top3Plaetze(ranking),
    alleRaenge: ranking,
    teilnehmerAnzahl: ranking.length,
    abgeschlossenAm: new Date().toISOString(),
    erstelltVon: erstelltVon || 'Admin'
  };
}
